// extracted by mini-css-extract-plugin
module.exports = {"serverUri":"style_serverUri__3wDJ515LrkAtKgcSnXK2sK","filterBoxStandardWidth":"style_filterBoxStandardWidth__1R3zIfBxdih87tewjBVIV3"};